export enum SupportIBD {

    Bryophytes = 1,
    Hydrophytes = 2,
    // Litieres = 3,
    // BranchageRacines = 4,
    PierreGalet = 5,
    // Graviers = 6,
    Helophytes = 7,
    // SedimentsFin = 8,
    // SablesLimons = 9,
    RochesDalles = 10,
    Algues = 11,
    // MarneArgile = 12,
    SubstratArtificielDurIntroduit = 13,
    SubstratArtificielSoupleIntroduit = 14
}
